import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, forkJoin, of } from 'rxjs';
import { catchError, map, debounceTime } from 'rxjs/operators';
import { URLS } from '../constants/URLS';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  formhttpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
  };

  constructor(
    private http: HttpClient,
    private apiService: ApiService
    ) { }

  getCCPrimeSearchData(searchKey: string) {
    console.log("getSearchData called");
    let body = new URLSearchParams();
    body.set('q', searchKey);
    body.set('contentsubtype','1')
    body.set('video_type', 'premium');
    return this.apiService.postForm(URLS.getSearchContent, body.toString(), this.formhttpOptions).pipe(
      map(responseData => {
        return responseData.data;
      }), catchError(errorRes => {
        return throwError(errorRes);
      }))
  }

  getPrimeSearchData(searchKey: string) {
    console.log("getSearchData called");
    let body = new URLSearchParams();
    body.set('q', searchKey);
    body.set('contentsubtype','2')
    body.set('video_type', 'premium');
    return this.apiService.postForm(URLS.getSearchContent, body.toString(), this.formhttpOptions).pipe(
      map(responseData => {
        return responseData.data;
      }), catchError(errorRes => {
        return throwError(errorRes);
      }))
  }

  getCCPrimeSuggestionSearchData(searchKey: string): Observable<any[]> {
    console.log("getCCPrimeSuggestionSearchData called");
    let body = new URLSearchParams();
    body.set('search_key', searchKey);
    body.set('contentsubtype', '1');
    
    return this.apiService.postForm(URLS.getSolrSearch, body.toString(), this.formhttpOptions).pipe(
      map(responseData => {
        console.log(responseData);
        if (responseData.status === '0' && responseData['status code'] === 404) {
          return []; // Return empty array if no data found
        }
        return responseData.data || []; // Safely return data or empty array
      }),
      catchError(errorRes => {
        console.error("Error fetching CC Prime data", errorRes);
        return of([]); // Return empty array on error
      })
    );
  }
  
  getPrimeSuggestionSearchData(searchKey: string): Observable<any[]> {
    console.log("getPrimeSuggestionSearchData called");
    let body = new URLSearchParams();
    body.set('search_key', searchKey);
    body.set('contentsubtype', '2');
    
    return this.apiService.postForm(URLS.getSolrSearch, body.toString(), this.formhttpOptions).pipe(
      map(responseData => {
        console.log(responseData);
        if (responseData.status === '0' && responseData['status code'] === 404) {
          return []; // Return empty array if no data found
        }
        return responseData.data || []; // Safely return data or empty array
      }),
      catchError(errorRes => {
        console.error("Error fetching Prime data", errorRes);
        return of([]); // Return empty array on error
      })
    );
  }
  
  getCombinedSuggestions(searchTerm: string): Observable<any[]> {
    return forkJoin([
      this.getCCPrimeSuggestionSearchData(searchTerm),
      this.getPrimeSuggestionSearchData(searchTerm)
    ]).pipe(
      map(([ccPrimeResults, primeResults]) => {
        return [...ccPrimeResults, ...primeResults]; // Combine both results
      }),
      debounceTime(300),
      catchError(error => {
        console.error("Error in combined suggestions", error);
        return of([]); // Return empty array if both requests fail
      })
    );
  }

  getSearchHistory() {
    console.log("getSearchData called");
    let body = new URLSearchParams();
    return this.apiService.postForm(URLS.getSearchHistory, body.toString(), this.formhttpOptions).pipe(
      map(responseData => {
        return responseData.data;
      }), catchError(errorRes => {
        return throwError(errorRes);
      }))
  }
}
